import BaseModel from '@/data/BaseModel';
import type { LocationSchema } from '@/data/location/schema';
import type { ISODateTime } from '@/shared/zod-schemas';

import type { z } from 'zod';

export type LocationFields = z.infer<typeof LocationSchema>;

class Location extends BaseModel<LocationFields>({
  id: 0,
  account_id: 0,
  name: '',
  address: null,
  coordinates: null,
  is_default: 0,
  is_deleted: false,
  latitude: null,
  longitude: null,
  ip_address: null,
  max_hours: 0,
  place: null,
  place_confirmed: false,
  place_id: 0,
  sort: 0,
  created_at: '' as ISODateTime,
  updated_at: '' as ISODateTime,
  deleted_at: null,
  updated_by: null,
  radius: undefined,
}) {}

export default Location;
